(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-v2"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotatorV2 extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-ab2-slide]')];
      this.index = 0;
      this.timer = null;

      this.querySelector('[data-ab2-prev]')?.addEventListener('click', () => this.step(-1, true));
      this.querySelector('[data-ab2-next]')?.addEventListener('click', () => this.step(1, true));

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.play());

      this.initCountdowns();
      this.play();
    }

    disconnectedCallback() {
      this.pause();
      if (this.tick) clearInterval(this.tick);
    }

    activeSlides() {
      return this.slides.filter((s) => !s.hasAttribute('data-ab2-expired'));
    }

    play() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.hasAttribute('data-autoplay') || reduced) return;
      if (this.activeSlides().length < 2) return;
      this.pause();
      const speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.timer = setInterval(() => this.step(1, false), speed);
    }

    pause() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    // A hidden slide must not keep a focusable link (axe: aria-hidden-focus),
    // so visibility, inert and tabindex always move together.
    show(slide, on) {
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      slide.toggleAttribute('inert', !on);
      slide.querySelectorAll('a, button').forEach((el) => {
        if (on) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    step(dir, user) {
      const slides = this.activeSlides();
      if (slides.length < 2) return;
      const current = slides.findIndex((s) => s.getAttribute('aria-hidden') === 'false');
      const next = (current + dir + slides.length) % slides.length;
      slides.forEach((s, i) => this.show(s, i === next));
      if (user) this.play();
    }

    initCountdowns() {
      const clocks = [...this.querySelectorAll('[data-ab2-countdown]')];
      if (!clocks.length) return;

      const zonedNext = (h, m, timeZone) => {
        const now = new Date();
        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-US', {
            timeZone,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false,
          }).formatToParts(now).map((p) => [p.type, p.value])
        );
        const wallAsUTC = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour % 24, parts.minute, parts.second);
        const offsetMs = wallAsUTC - now.getTime();
        let target = Date.UTC(parts.year, parts.month - 1, parts.day, h, m, 0) - offsetMs;
        if (target <= now.getTime()) target += 86400000;
        return target;
      };

      // A fixed end ("2026-10-26T00:00") is a wall time in the block's zone
      // (shop time, Eastern), not the visitor's: convert it once.
      const zonedAt = (wall, timeZone) => {
        const [date, time] = wall.split('T');
        const [y, mo, d] = date.split('-').map(Number);
        const [h, mi] = (time || '23:59').split(':').map(Number);
        const guess = Date.UTC(y, mo - 1, d, h, mi, 0);
        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-US', {
            timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
          }).formatToParts(new Date(guess)).map((p) => [p.type, p.value])
        );
        const wallOfGuess = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour % 24, parts.minute, parts.second);
        return guess - (wallOfGuess - guess);
      };

      const endFor = (clock) => {
        if (clock.dataset.mode === 'fixed' && clock.dataset.end) {
          const zone = clock.dataset.timezone;
          if (zone && zone !== 'local' && !/[zZ]|[+-]\d\d:?\d\d$/.test(clock.dataset.end)) {
            try {
              return zonedAt(clock.dataset.end, zone);
            } catch (e) {
              // fall through to visitor-local if the zone id is bad
            }
          }
        }
        if (clock.dataset.mode === 'daily') {
          const [h, m] = (clock.dataset.resetTime || '23:59').split(':').map(Number);
          const zone = clock.dataset.timezone;
          if (zone && zone !== 'local') {
            try {
              return zonedNext(h, m, zone);
            } catch (e) {
              // fall through to visitor-local if the zone id is bad
            }
          }
          const now = new Date();
          const reset = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, 0);
          if (now >= reset) reset.setDate(reset.getDate() + 1);
          return reset.getTime();
        }
        return new Date(clock.dataset.end).getTime();
      };

      const render = () => {
        const now = Date.now();
        clocks.forEach((clock) => {
          let end = endFor(clock);
          let diff = end - now;

          if (diff <= 0 && clock.dataset.mode === 'fixed') {
            const slide = clock.closest('[data-ab2-slide]');
            if (clock.dataset.completeText) {
              const text = slide.querySelector('.ab2__text');
              if (text && !slide.hasAttribute('data-ab2-complete')) {
                text.textContent = clock.dataset.completeText;
                clock.remove();
                slide.setAttribute('data-ab2-complete', '');
              }
            } else if (!slide.hasAttribute('data-ab2-expired')) {
              slide.setAttribute('data-ab2-expired', '');
              this.show(slide, false);
              const remaining = this.activeSlides();
              if (remaining.length && !remaining.some((s) => s.getAttribute('aria-hidden') === 'false')) {
                this.show(remaining[0], true);
              }
            }
            return;
          }

          if (diff < 0) diff = 0;
          const units = {
            days: Math.floor(diff / 86400000),
            hours: Math.floor((diff % 86400000) / 3600000),
            minutes: Math.floor((diff % 3600000) / 60000),
            seconds: Math.floor((diff % 60000) / 1000),
          };
          Object.entries(units).forEach(([unit, value]) => {
            const el = clock.querySelector(`[data-unit="${unit}"]`);
            if (el) el.textContent = String(value).padStart(2, '0');
          });
        });
      };

      render();
      this.tick = setInterval(render, 1000);
    }
  }

  if (!customElements.get('announcement-rotator-v2')) {
    customElements.define('announcement-rotator-v2', AnnouncementRotatorV2);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bean-bags-category-filter"] && !Shopify.designMode) return;
  try {
    
  if (!window.__cordBbcfInit) {
    window.__cordBbcfInit = true;
    const PARAM = 'filter.p.product_type';
    const prefix = 'shopify-section-';

    let controller = null;
    const rerender = () => {
      document.querySelectorAll('[data-bbcf-section]').forEach((list) => {
        const id = list.dataset.bbcfSection;
        const requestUrl = new URL(window.location.href);
        requestUrl.searchParams.set('section_id', id);
        if (controller) controller.abort();
        controller = new AbortController();
        fetch(requestUrl.toString(), { signal: controller.signal })
          .then((r) => { if (!r.ok) throw new Error('render failed'); return r.text(); })
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.getElementById(prefix + id);
            const current = document.getElementById(prefix + id);
            if (next && current) current.replaceWith(next);
          })
          .catch((e) => { if (e && e.name === 'AbortError') return; });
      });
    };
    document.addEventListener('shopify:collection:update', rerender, true);
    window.addEventListener('popstate', rerender);

    document.addEventListener('click', (event) => {
      const tile = event.target.closest('[data-bbcf-types]');
      if (!tile) return;
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

      const facetsForm = document.querySelector('facets-form-component');
      if (!(facetsForm && typeof facetsForm.updateFiltersByURL === 'function')) return; // plain link fallback

      event.preventDefault();
      // Single-select category chooser, built from the CURRENT URL so size /
      // fabric / price stay put: clicking a tile swaps the product-type set
      // for that tile's set; clicking the lit tile clears the set.
      const url = new URL(window.location.href);
      const wasOn = tile.getAttribute('aria-pressed') === 'true';
      url.searchParams.delete(PARAM);
      if (!wasOn) tile.dataset.bbcfTypes.split('|').forEach((t) => url.searchParams.append(PARAM, t));
      url.searchParams.delete('page');
      facetsForm.updateFiltersByURL(url.toString());
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-quick-filter-buttons"] && !Shopify.designMode) return;
  try {
    
  if (!window.__cordQuickFilterInit) {
    window.__cordQuickFilterInit = true;
    const sectionPrefix = 'shopify-section-';
    const mobileStackQuery = window.matchMedia('(max-width: 749px)');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // The status line is announced after the section re-renders (the
    // re-render replaces the node that carried it), so keep it here.
    let pendingStatus = '';

    const getScrollHint = (wrapper) =>
      wrapper.closest('.quick-collection-filter')?.querySelector('[data-scroll-hint]');

    const updateScrollHint = (wrapper, canScroll) => {
      const hint = getScrollHint(wrapper);
      if (!hint) return;
      const dismissed = wrapper.dataset.scrollHintDismissed === 'true';
      if (canScroll && !dismissed) {
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    };

    const scrollActiveButtonIntoView = (wrapper) => {
      const scroller = wrapper.querySelector('.quick-collection-filter__list--scroll');
      if (!scroller) return;
      const activeButton = scroller.querySelector('.quick-collection-filter__button.is-active');
      if (!activeButton) return;
      const buttonRect = activeButton.getBoundingClientRect();
      const scrollerRect = scroller.getBoundingClientRect();
      if (buttonRect.left < scrollerRect.left || buttonRect.right > scrollerRect.right) {
        activeButton.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
      }
    };

    const isStackedMobileLayout = (wrapper) => {
      const filter = wrapper.closest('.quick-collection-filter');
      if (!filter) return false;
      return filter.classList.contains('quick-collection-filter--stack-mobile') && mobileStackQuery.matches;
    };

    const evaluateScrollWrapper = (wrapper, shouldRevealActive = false) => {
      const scroller = wrapper.querySelector('.quick-collection-filter__list--scroll');
      if (!scroller) return;
      if (isStackedMobileLayout(wrapper)) {
        wrapper.dataset.scrollable = 'false';
        wrapper.removeAttribute('data-scroll-hint-dismissed');
        updateScrollHint(wrapper, false);
        return;
      }
      const canScroll = scroller.scrollWidth - scroller.clientWidth > 1;
      if (canScroll) {
        wrapper.dataset.scrollable = 'true';
      } else {
        wrapper.dataset.scrollable = 'false';
        wrapper.removeAttribute('data-scroll-hint-dismissed');
      }
      updateScrollHint(wrapper, canScroll);
      if (shouldRevealActive) {
        scrollActiveButtonIntoView(wrapper);
      }
    };

    const initQuickFilterScrollWrappers = () => {
      document.querySelectorAll('.quick-collection-filter__scroll-wrapper').forEach((wrapper) => {
        const scroller = wrapper.querySelector('.quick-collection-filter__list--scroll');
        if (!scroller) return;
        const isFirstInit = wrapper.dataset.scrollInit !== 'true';
        wrapper.dataset.scrollInit = 'true';
        evaluateScrollWrapper(wrapper, isFirstInit);

        if (wrapper.dataset.scrollListenerBound === 'true') return;
        wrapper.dataset.scrollListenerBound = 'true';

        let scrollScheduled = false;
        scroller.addEventListener('scroll', () => {
          if (scrollScheduled) return;
          scrollScheduled = true;
          requestAnimationFrame(() => {
            evaluateScrollWrapper(wrapper);
            if (scroller.scrollLeft > 4) {
              wrapper.dataset.scrollHintDismissed = 'true';
            } else {
              wrapper.removeAttribute('data-scroll-hint-dismissed');
            }
            scrollScheduled = false;
          });
        });
      });
    };

    window.addEventListener('resize', () => initQuickFilterScrollWrappers());

    // Both steps live in ONE section (the size group's data attribute is
    // "<section.id>-g2"), so one Section Rendering fetch refreshes every chip.
    const baseSectionIdOf = (id) => (id || '').replace(/-(g[23]|nudge)$/, '');
    const quickFilterSectionIds = () => {
      const ids = new Set();
      document.querySelectorAll('[data-quick-filter-section]').forEach((el) => {
        const id = baseSectionIdOf(el.dataset.quickFilterSection);
        if (id) ids.add(id);
      });
      return [...ids];
    };

    // One in-flight request per picker section. A single shared controller
    // made a page with two pickers (size + fabric strips) abort its first
    // section's refresh while starting the second, so the tapped chip in
    // the first strip never lit.
    const quickFilterRenderControllers = new Map();
    const renderQuickFilterSection = (sectionId, url) => {
      if (!sectionId || !url) return;

      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);

      // Rapid taps used to stack un-aborted fetches; whichever resolved
      // last replaced the section, sometimes out of order.
      const previous = quickFilterRenderControllers.get(sectionId);
      if (previous) previous.abort();
      const controller = new AbortController();
      quickFilterRenderControllers.set(sectionId, controller);

      fetch(requestUrl.toString(), { signal: controller.signal })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Section render failed');
          }
          return response.text();
        })
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const nextSection = doc.getElementById(`${sectionPrefix}${sectionId}`);
          const currentSection = document.getElementById(`${sectionPrefix}${sectionId}`);
          if (nextSection && currentSection) {
            currentSection.replaceWith(nextSection);
            initQuickFilterScrollWrappers();
            initPickBar();
            if (pendingStatus) {
              const status = nextSection.querySelector('[data-qfb-status]');
              if (status) status.textContent = pendingStatus;
              pendingStatus = '';
            }
          }
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          window.location.assign(url);
        });
    };

    // The chips must always mirror the URL the page is actually on. The old
    // code had a "fast path" that flipped chip classes locally and skipped
    // the re-render after a single-select tap — which left every OTHER
    // chip holding a link built for the previous state. Symptoms Steve's
    // tester logged: Nest then Queen dropped Nest; deselecting Nest left
    // Queen lit; Clear all in the drawer left tiles lit; Youth stayed greyed
    // after switching Nest -> Original. One rule now: after ANY filter
    // change (chip, drawer checkbox, Clear all, back button) re-render the
    // chooser from window.location.
    const syncQuickFiltersToLocation = () => {
      quickFilterSectionIds().forEach((id) => renderQuickFilterSection(id, window.location.href));
    };
    document.addEventListener('shopify:collection:update', syncQuickFiltersToLocation, true);
    window.addEventListener('popstate', syncQuickFiltersToLocation);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-filter-url]');
      if (!trigger) return;

      if (
        event.defaultPrevented ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button !== 0
      ) {
        return;
      }

      const url = trigger.dataset.quickFilterUrl || trigger.getAttribute('href');
      if (!url) return;

      const facetsForm = document.querySelector('facets-form-component');
      if (!(facetsForm && typeof facetsForm.updateFiltersByURL === 'function')) return;

      const sectionsWrapper = trigger.closest('[data-quick-filter-section]');
      const isSingleSelect = sectionsWrapper?.dataset.quickFilterSingleSelect === 'true';
      const groupParam = sectionsWrapper?.dataset.quickFilterParam;

      event.preventDefault();

      // Build the destination from the CURRENT URL, never from the chip's
      // own href — the href was rendered for whatever state the page was in
      // when the chips last rendered, and can be stale. Toggle semantics:
      // tap an active value to remove it; single-select replaces siblings.
      let destinationUrl = url;
      const value = trigger.dataset.quickFilterValue || '';
      let wasActive = trigger.classList.contains('is-active');
      if (groupParam) {
        const parsedUrl = new URL(window.location.href);
        const activeValues = parsedUrl.searchParams.getAll(groupParam);
        wasActive = wasActive || activeValues.includes(value);
        parsedUrl.searchParams.delete(groupParam);
        if (!isSingleSelect) {
          activeValues.filter((v) => v !== value).forEach((v) => parsedUrl.searchParams.append(groupParam, v));
        }
        if (!wasActive) parsedUrl.searchParams.append(groupParam, value);
        parsedUrl.searchParams.delete('page');
        destinationUrl = parsedUrl.toString();
      }

      const filterContainer = trigger.closest('.quick-collection-filter');
      filterContainer?.classList.add('quick-collection-filter--loading');

      // pushState + grid render + shopify:collection:update, which the
      // listener above turns into the chooser re-render.
      facetsForm.updateFiltersByURL(destinationUrl);

      // Tell assistive tech what just happened; the grid re-renders silently.
      const status = trigger.closest('.quick-filter-buttons-section')?.querySelector('[data-qfb-status]');
      const label = trigger.querySelector('.quick-collection-filter__label-value')?.textContent.trim() || value;
      if (trigger.hasAttribute('data-qfb-clear')) {
        pendingStatus = 'All filters cleared. Products updated.';
      } else {
        pendingStatus = wasActive ? `${label} filter removed. Products updated.` : `Showing ${label}. Products updated.`;
      }
      if (status) status.textContent = pendingStatus;

      // A size card inside the drawer: close through the component so the
      // scroll lock is released and focus returns to the trigger.
      const host = trigger.closest('dialog-component');
      if (host && typeof host.closeDialog === 'function') host.closeDialog();
      else trigger.closest('dialog')?.close();
    });

    // The cover finder: one question per screen, ends by applying filters.
    const finderNeedsSize = (family) => ['Original', 'NEST', 'Dog Bed'].includes(family);
    // Opening the finder always starts at screen one, even after a Close
    // mid-flow (the dialog keeps its DOM, so the state would otherwise stick).
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.size-guide-popup__trigger');
      if (!trigger) return;
      const finder = trigger.closest('dialog-component')?.querySelector('[data-finder]');
      if (!finder) return;
      finder.__state = { family: '', size: '', history: [] };
      finder.querySelectorAll('[data-finder-screen]').forEach((screen) => {
        screen.hidden = screen.dataset.finderScreen !== 'family';
      });
      const help = finder.querySelector('[data-finder-help-panel]');
      const helpToggle = finder.querySelector('[data-finder-help]');
      if (help) help.hidden = true;
      if (helpToggle) helpToggle.setAttribute('aria-expanded', 'false');
    });
    const finderShow = (finder, name) => {
      finder.querySelectorAll('[data-finder-screen]').forEach((screen) => {
        screen.hidden = screen.dataset.finderScreen !== name;
      });
      const heading = finder.querySelector(`[data-finder-screen="${name}"] .cfinder__title`);
      if (heading) heading.setAttribute('tabindex', '-1'), heading.focus({ preventScroll: true });
    };
    const finderShowSizes = (finder, state) => {
      finder.querySelectorAll('[data-finder-sizes]').forEach((group) => {
        group.hidden = group.dataset.finderSizes !== state.family;
      });
      const step = finder.querySelector('[data-finder-size-step]');
      if (step) step.textContent = state.history.includes('pillow') ? 'Step 3' : 'Step 2';
      finderShow(finder, 'size');
    };
    const finderResult = (finder, state) => {
      const out = finder.querySelector('[data-finder-result]');
      if (out) out.textContent = `${state.size ? state.size + ' ' : ''}${state.family} covers`;
      finderShow(finder, 'result');
    };
    document.addEventListener('click', (event) => {
      const finder = event.target.closest('[data-finder]');
      if (!finder) return;
      const button = event.target.closest('[data-finder-family],[data-finder-pillow],[data-finder-size],[data-finder-back],[data-finder-apply],[data-finder-restart],[data-finder-help]');
      if (!button) return;
      event.preventDefault();
      const state = finder.__state || (finder.__state = { family: '', size: '', history: [] });
      const current = () => finder.querySelector('[data-finder-screen]:not([hidden])')?.dataset.finderScreen || 'family';
      if (button.hasAttribute('data-finder-help')) {
        const panel = finder.querySelector('[data-finder-help-panel]');
        if (!panel) return;
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
        return;
      }
      if (button.hasAttribute('data-finder-family')) {
        state.family = button.dataset.finderFamily;
        state.size = '';
        state.history = ['family'];
        if (state.family === 'Original' && finder.querySelector('[data-finder-screen="pillow"]')) finderShow(finder, 'pillow');
        else if (finderNeedsSize(state.family)) finderShowSizes(finder, state);
        else finderResult(finder, state);
        return;
      }
      if (button.hasAttribute('data-finder-pillow')) {
        state.history.push('pillow');
        if (button.dataset.finderPillow === 'yes') state.family = 'NEST';
        finderShowSizes(finder, state);
        return;
      }
      if (button.hasAttribute('data-finder-size')) {
        state.size = button.dataset.finderSize;
        state.history.push('size');
        finderResult(finder, state);
        return;
      }
      if (button.hasAttribute('data-finder-back')) {
        const previous = state.history.pop() || 'family';
        if (previous === 'family') { state.family = ''; state.size = ''; state.history = []; }
        if (previous === 'pillow') state.family = 'Original';
        if (previous === 'size') state.size = '';
        if (previous === 'size') finderShowSizes(finder, state); else finderShow(finder, previous);
        return;
      }
      if (button.hasAttribute('data-finder-restart')) {
        state.family = ''; state.size = ''; state.history = [];
        finderShow(finder, 'family');
        return;
      }
      if (button.hasAttribute('data-finder-apply')) {
        // Start from the current URL so sort_by and unrelated filters (a
        // colour, a price) survive; replace only family and size.
        const url = new URL(window.location.href);
        url.pathname = new URL(finder.dataset.finderUrl, window.location.origin).pathname;
        url.searchParams.delete(finder.dataset.finderFamilyParam);
        url.searchParams.delete(finder.dataset.finderSizeParam);
        url.searchParams.delete('page');
        url.searchParams.set(finder.dataset.finderFamilyParam, state.family);
        if (state.size) url.searchParams.set(finder.dataset.finderSizeParam, state.size);
        const facetsForm = document.querySelector('facets-form-component');
        if (!facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') {
          window.location.assign(url.toString());
          return;
        }
        // Close through the component so the scroll lock is released; it
        // restores the pre-open scroll position, so scroll to the picker after.
        const component = finder.closest('dialog-component');
        const closed = typeof component?.closeDialog === 'function' ? component.closeDialog() : Promise.resolve(finder.closest('dialog')?.close());
        Promise.resolve(closed).then(() => {
          state.family = ''; state.size = ''; state.history = [];
          finderShow(finder, 'family');
          // Instant, and before the filter update: the re-render scrolls the
          // active chip into view, which would cancel a smooth scroll in flight.
          const picker = document.querySelector('.quick-filter-buttons-section');
          if (picker) picker.scrollIntoView({ behavior: 'auto', block: 'start' });
          facetsForm.updateFiltersByURL(url.toString());
        });
      }
    });

    // Phones: tapping an answered step's summary re-opens its rail.
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-qfb-toggle]');
      if (!toggle) return;
      const step = toggle.closest('.qfb-step');
      if (!step) return;
      const open = !step.classList.contains('is-open');
      step.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Sticky "your pick" bar: shows on phones once the picker has scrolled
    // above the viewport; Change scrolls back up. Re-armed after re-renders.
    let pickBarObserver = null;
    const initPickBar = () => {
      if (pickBarObserver) { pickBarObserver.disconnect(); pickBarObserver = null; }
      const bar = document.querySelector('[data-qfb-pickbar]');
      const picker = document.querySelector('.quick-filter-buttons-section');
      document.body.classList.remove('qfb-pickbar-on');
      if (!bar || !picker || !('IntersectionObserver' in window)) return;
      pickBarObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        bar.hidden = !show;
        document.body.classList.toggle('qfb-pickbar-on', show);
      }, { threshold: 0 });
      pickBarObserver.observe(picker);
    };
    document.addEventListener('click', (event) => {
      const change = event.target.closest('[data-qfb-pickbar-change]');
      if (!change) return;
      const picker = document.querySelector('.quick-filter-buttons-section');
      if (picker) picker.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    });

    // A "#which-cover-fits" link anywhere on the page (the hero button)
    // opens step 1's popup; if the step isn't rendered, just scroll there.
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href$="#which-cover-fits"]');
      if (!link) return;
      const picker = document.querySelector('.quick-filter-buttons-section');
      if (!picker) return;
      event.preventDefault();
      picker.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      const trigger = picker.querySelector('.qfb-step[data-group="g1"] .size-guide-popup__trigger');
      if (trigger) trigger.click();
    });

    // Chips are links exposed as buttons; Space must activate them too.
    document.addEventListener('keydown', (event) => {
      if (event.key !== ' ') return;
      const chip = event.target.closest('[data-quick-filter-url][role="button"]');
      if (!chip) return;
      event.preventDefault();
      chip.click();
    });

    initQuickFilterScrollWrappers();
    initPickBar();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-spectrum"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cspec]');
    if (!root) return;

    var fabricMap = {};
    try { fabricMap = JSON.parse((root.querySelector('[data-cspec-fabric-map]') || {}).textContent || '{}'); } catch (e) {}

    function hexToHsl(hex) {
      var n = parseInt(hex.slice(1), 16);
      var r = (n >> 16 & 255) / 255, g = (n >> 8 & 255) / 255, b = (n & 255) / 255;
      var max = Math.max(r, g, b), min = Math.min(r, g, b);
      var h = 0, s = 0, l = (max + min) / 2;
      if (max !== min) {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
        else if (max === g) h = (b - r) / d + 2;
        else h = (r - g) / d + 4;
        h /= 6;
      }
      return { h: h * 360, s: s * 100, l: l * 100 };
    }

    var shades = [].map.call(root.querySelectorAll('[data-cspec-shade]'), function (el) {
      var hex = el.dataset.hex || '#cccccc';
      var hsl = hexToHsl(hex);
      return {
        name: el.dataset.name, hex: hex, hsl: hsl,
        fabrics: (el.dataset.fabrics || '').split(',').map(function (f) { return f.trim(); }).filter(Boolean),
        zone: el.dataset.zone || 'spectrum',
        link: el.dataset.link || ''
      };
    });

    var spectrum = shades.filter(function (c) { return c.zone === 'spectrum'; }).sort(function (a, b) { return a.hsl.h - b.hsl.h; });
    var neutrals = shades.filter(function (c) { return c.zone === 'neutral'; }).sort(function (a, b) { return b.hsl.l - a.hsl.l; });

    var el = function (sel) { return root.querySelector(sel); };
    var activeBtn = null;

    function prodTypesFor(fabrics) {
      var set = {};
      fabrics.forEach(function (f) { (fabricMap[f] || []).forEach(function (p) { set[p] = 1; }); });
      return Object.keys(set);
    }

    var fabricsLink = root.dataset.fabricsLink || '';

    function fillChips(wrapSel, chipsSel, items, cls, linkable) {
      var wrap = el(wrapSel), box = el(chipsSel);
      if (!items.length) { wrap.hidden = true; return; }
      wrap.hidden = false;
      box.innerHTML = '';
      items.forEach(function (t) {
        var s;
        if (linkable && fabricsLink) {
          s = document.createElement('a');
          s.href = fabricsLink;
          s.title = 'Explore ' + t + ' on the fabrics page';
        } else {
          s = document.createElement('span');
        }
        s.className = 'cspec__chip ' + cls;
        s.textContent = t;
        box.appendChild(s);
      });
    }

    function select(c, btn) {
      if (activeBtn) {
        activeBtn.classList.remove('is-active');
        if (activeBtn.hasAttribute('aria-pressed')) activeBtn.setAttribute('aria-pressed', 'false');
      }
      if (btn) {
        btn.classList.add('is-active');
        if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', 'true');
        activeBtn = btn;
      }
      el('[data-cspec-swatch]').style.background = c.hex || c.bg || '#eee';
      el('[data-cspec-name]').textContent = c.name;
      var hexEl = el('[data-cspec-hex]');
      if (c.hex) { hexEl.hidden = false; hexEl.textContent = c.hex.toUpperCase(); } else { hexEl.hidden = true; }
      var prods = prodTypesFor(c.fabrics);
      el('[data-cspec-avail]').textContent = c.hex
        ? 'Comes in ' + c.fabrics.length + ' fabric' + (c.fabrics.length === 1 ? '' : 's') + (prods.length ? ' · ' + prods.length + ' product lines' : '')
        : 'Pattern · ' + c.fabrics.join(', ');
      fillChips('[data-cspec-fabrics-wrap]', '[data-cspec-fabrics]', c.fabrics, 'cspec__chip--fabric', true);
      fillChips('[data-cspec-prods-wrap]', '[data-cspec-prods]', prods, 'cspec__chip--prod');
      var cta = el('[data-cspec-link]');
      if (c.link) { cta.hidden = false; cta.href = c.link; cta.textContent = 'Shop ' + c.name + ' →'; } else { cta.hidden = true; }
      if (c.hex && c.hsl && c.zone === 'spectrum') {
        el('[data-cspec-marker]').style.left = (c.hsl.h / 360 * 100) + '%';
      }
    }

    function buildSwatch(c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cspec__sw';
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML =
        '<span class="cspec__sw-chip" style="background:' + c.hex + '">' +
          '<span class="cspec__sw-cnt">' + c.fabrics.length + (c.fabrics.length === 1 ? ' fabric' : ' fabrics') + '</span>' +
        '</span>' +
        '<span class="cspec__sw-nm"></span>';
      btn.querySelector('.cspec__sw-nm').textContent = c.name;
      btn.addEventListener('click', function () { select(c, btn); });
      return btn;
    }

    var stTrack = el('[data-cspec-track="spectrum"]');
    var ntTrack = el('[data-cspec-track="neutral"]');
    spectrum.forEach(function (c) { stTrack.appendChild(buildSwatch(c)); });
    neutrals.forEach(function (c) { ntTrack.appendChild(buildSwatch(c)); });
    el('[data-cspec-count-spectrum]').textContent = spectrum.length + ' shades, red → violet';
    el('[data-cspec-count-neutral]').textContent = neutrals.length + ' shades, light → dark';

    root.querySelectorAll('[data-cspec-pattern]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var c = {
          name: btn.dataset.name, bg: btn.dataset.bg,
          fabrics: (btn.dataset.fabrics || '').split(',').map(function (f) { return f.trim(); }).filter(Boolean),
          link: btn.dataset.link || ''
        };
        select(c, btn);
      });
    });

    root.querySelectorAll('[data-cspec-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var track = el('[data-cspec-track="' + btn.dataset.cspecScroll + '"]');
        if (track) track.scrollBy({ left: 340 * Number(btn.dataset.dir || 1), behavior: 'smooth' });
      });
    });

    if (spectrum.length) select(spectrum[0], stTrack.firstChild);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["covers-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cvl]');
    if (!root) return;
    var state = { chair: null, pillow: null };
    var q2 = root.querySelector('[data-cvl-q2]');

    function refresh() {
      if (q2) q2.hidden = !state.chair;
      root.querySelectorAll('[data-cvl-answer]').forEach(function (a) {
        a.hidden = !(state.chair && state.pillow && a.dataset.chair === state.chair && a.dataset.pillow === state.pillow);
      });
    }

    root.querySelectorAll('[data-cvl-q]').forEach(function (group) {
      var key = group.dataset.cvlQ;
      group.querySelectorAll('.cvl__opt').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state[key] = btn.dataset.val;
          group.querySelectorAll('.cvl__opt').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
          refresh();
          var visible = root.querySelector('[data-cvl-answer]:not([hidden])');
          if (visible) visible.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-help-center"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-faq]');
    if (!root) return;

    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-faq-cat]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var search = root.querySelector('[data-faq-search]');
    var pillBar = root.querySelector('[data-faq-pills]');
    var empty = root.querySelector('[data-faq-empty]');
    var results = root.querySelector('[data-faq-results]');
    var clearBtn = root.querySelector('[data-faq-clear]');
    var active = 'all';

    function countIn(cat) {
      return cat.querySelectorAll('[data-faq-item]:not(.is-hidden)').length;
    }

    function refreshCounts() {
      var anyVisible = false;
      cats.forEach(function (cat) {
        var n = countIn(cat);
        var badge = cat.querySelector('[data-faq-count]');
        if (badge) badge.textContent = n === 1 ? '1 question' : n + ' questions';
        var hide = n === 0 || (active !== 'all' && cat.dataset.faqCat !== active);
        cat.classList.toggle('is-hidden', hide);
        if (!hide) anyVisible = true;
      });
      if (empty) empty.hidden = anyVisible;
    }

    // Topic pills are derived from the rendered categories — no second list.
    if (pillBar && cats.length) {
      var mk = function (label, value) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'faq__pill';
        b.textContent = label;
        b.setAttribute('aria-pressed', value === active ? 'true' : 'false');
        b.addEventListener('click', function () {
          active = value;
          pillBar.querySelectorAll('.faq__pill').forEach(function (p) {
            p.setAttribute('aria-pressed', p === b ? 'true' : 'false');
          });
          refreshCounts();
          if (value !== 'all') {
            var target = root.querySelector('[data-faq-cat="' + value + '"]');
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
        return b;
      };
      pillBar.appendChild(mk('All Topics', 'all'));
      cats.forEach(function (cat) {
        pillBar.appendChild(mk(cat.dataset.faqCatTitle || 'Topic', cat.dataset.faqCat));
      });
    }

    if (search) {
      // Every word has to appear somewhere in the question, answer or tip.
      // Matching on terms rather than the raw string means "wash cover" finds
      // an answer that says "machine wash the outer cover".
      var run = function () {
        var raw = search.value.trim();
        var terms = raw.toLowerCase().split(/\s+/).filter(Boolean);
        var hits = 0;

        items.forEach(function (item) {
          var hay = item.dataset.search || '';
          var hit = terms.every(function (t) { return hay.indexOf(t) !== -1; });
          item.classList.toggle('is-hidden', !hit);
          if (hit) hits++;
          if (!terms.length) item.open = false;
        });

        // Auto-open only a short result list — opening 40 answers at once
        // buries the thing the person was looking for.
        if (terms.length && hits > 0 && hits <= 4) {
          items.forEach(function (item) {
            if (!item.classList.contains('is-hidden')) item.open = true;
          });
        }

        if (terms.length) {
          active = 'all';
          if (pillBar) pillBar.querySelectorAll('.faq__pill').forEach(function (p, i) {
            p.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
          });
        }

        // The topic pills filter by category, which a text search already
        // supersedes — and on mobile that whole row was the thing burying
        // the results. Hide it while a search is active; clearing restores it.
        if (pillBar) pillBar.hidden = !!terms.length;

        if (clearBtn) clearBtn.hidden = !raw;
        if (results) {
          results.hidden = !terms.length || hits === 0;
          if (!results.hidden) {
            results.textContent = (hits === 1 ? '1 result for ' : hits + ' results for ') + '“' + raw + '”';
          }
        }
        refreshCounts();
      };

      search.addEventListener('input', run);
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          search.value = '';
          run();
          search.focus();
        });
      }
    }

    // Supporting videos load only when their answer is opened, so a page of
    // 70 questions never spins up 70 players.
    root.querySelectorAll('[data-faq-video]').forEach(function (fig) {
      var item = fig.closest('[data-faq-item]');
      if (!item) return;
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var frame = fig.querySelector('.faq-item__frame');
        if (!frame || frame.dataset.loaded) return;
        var id = fig.getAttribute('data-faq-video');
        var type = fig.getAttribute('data-faq-video-type');
        if (!id) return;
        var src = type === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id
          : 'https://www.youtube.com/embed/' + id;
        var f = document.createElement('iframe');
        f.src = src;
        f.loading = 'lazy';
        f.allow = 'accelerometer; encrypted-media; picture-in-picture; fullscreen';
        f.allowFullscreen = true;
        f.title = (item.querySelector('.faq-item__q span') || {}).textContent || 'Video';
        frame.appendChild(f);
        frame.dataset.loaded = '1';
      });
    });

    refreshCounts();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footprint-viewer"] && !Shopify.designMode) return;
  try {
    
  class FootprintViewer extends HTMLElement {
    connectedCallback() {
      this.circle = this.querySelector('[data-fp-circle]');
      this.dimline = this.querySelector('[data-fp-dimline]');
      this.dimtext = this.querySelector('[data-fp-dimtext]');
      this.nameEl = this.querySelector('[data-fp-name]');
      this.panels = [...this.querySelectorAll('[data-fp-panel]')];
      if (!this.circle || this.panels.length === 0) return;

      const chipWrap = this.querySelector('[data-fp-chips]');
      this.chips = new Map();
      if (chipWrap) {
        this.panels.forEach((panel) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = panel.dataset.fpSize;
          btn.addEventListener('click', () => {
            this.setSize(panel.dataset.fpSize);
            panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          chipWrap.append(btn);
          this.chips.set(panel.dataset.fpSize, btn);
        });
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.setSize(entry.target.dataset.fpSize);
          });
        },
        { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
      );
      this.panels.forEach((p) => this.observer.observe(p));

      this.setSize(this.panels[0].dataset.fpSize);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    setSize(name) {
      const panel = this.panels.find((p) => p.dataset.fpSize === name);
      if (!panel) return;
      const d = parseFloat(panel.dataset.fpFloor);
      if (!d) return;

      const cx = 48;
      const r = d / 2;
      this.circle.setAttribute('r', r);
      this.dimline.setAttribute('x1', cx - r);
      this.dimline.setAttribute('x2', cx + r);
      this.dimtext.textContent = d + '" across';
      this.nameEl.textContent = name;
      this.chips.forEach((btn, key) => btn.setAttribute('aria-current', key === name ? 'true' : 'false'));
      this.currentSize = name;
    }
  }

  if (!customElements.get('footprint-viewer')) {
    customElements.define('footprint-viewer', FootprintViewer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mega"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.cr-mega');
    if (!root) return;
    var drawer = document.querySelector('[data-cr-drawer]');
    var overlay = document.querySelector('[data-cr-overlay]');
    var burger = root.querySelector('[data-cr-burger]');
    var panels = drawer ? drawer.querySelector('[data-cr-panels]') : null;
    var stack = ['root'];

    var CARET = '<svg viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5"/></svg>';
    var ALL_VALUES = ['all', 'show all', 'any', ''];

    // ---- Mobile drawer, generated from the rendered desktop panels ----------
    function drawerBodyFor(panel) {
      var frag = document.createDocumentFragment();
      // A panel can mix layouts: top-level cards (cards layout) PLUS groups
      // (e.g. a "Find your fit" row inside the Convertibles panel). Take the
      // top-level cards first, then each group with its label — assuming
      // group-presence means groups-only silently drops the main cards.
      panel.querySelectorAll('.cr-mega__card').forEach(function (c) {
        if (c.closest('.cr-mega__group')) return;
        frag.appendChild(c.cloneNode(true));
      });
      panel.querySelectorAll('.cr-mega__group').forEach(function (g) {
        var h = g.querySelector('h4');
        if (h) {
          var lbl = document.createElement('div');
          lbl.className = 'cr-mega-drawer__group-label';
          lbl.textContent = h.textContent;
          frag.appendChild(lbl);
        }
        g.querySelectorAll('.cr-mega__card').forEach(function (c) { frag.appendChild(c.cloneNode(true)); });
      });
      var promo = panel.querySelector('.cr-mega__promo');
      if (promo) frag.appendChild(promo.cloneNode(true));
      return frag;
    }

    function shopAllTextFor(panel, label) {
      var shopAll = panel.querySelector('.cr-mega__shopall');
      if (!shopAll) return null;
      var base = (shopAll.textContent || '').replace(/[→>\s]+$/, '').trim();
      return base + ' ' + label + ' →';
    }

    // ---- "Photo accordion" drawer (prototype style) ------------------------
    function buildAccordion() {
      drawer.classList.add('cr-mega-drawer--acc');
      panels.innerHTML = '';
      var wrap = document.createElement('div');
      wrap.className = 'cr-mega-drawer__acc';

      // Featured strip from cards flagged "feature in drawer"
      var featured = root.querySelectorAll('.cr-mega__card[data-cr-feature]');
      if (featured.length) {
        var heading = root.dataset.featuredHeading;
        if (heading) {
          var h = document.createElement('h3');
          h.className = 'cr-mega-drawer__featured-heading';
          h.textContent = heading;
          wrap.appendChild(h);
        }
        var fg = document.createElement('div');
        fg.className = 'cr-mega-drawer__featured-grid';
        featured.forEach(function (c) { fg.appendChild(c.cloneNode(true)); });
        wrap.appendChild(fg);
      }

      root.querySelectorAll('[data-cr-item]').forEach(function (item) {
        var link = item.querySelector('.cr-mega__link');
        if (!link) return;
        var label = (link.textContent || '').trim();
        var href = link.getAttribute('href') || '#';
        var panel = item.querySelector('.cr-mega__panel');
        var hasCards = panel && panel.querySelector('.cr-mega__card');

        if (!hasCards) {
          var a = document.createElement('a');
          a.className = 'cr-mega-drawer__acc-link';
          a.href = href;
          a.textContent = label;
          wrap.appendChild(a);
          return;
        }

        var group = document.createElement('div');
        group.className = 'cr-mega-drawer__acc-group';
        var btn = document.createElement('button');
        btn.className = 'cr-mega-drawer__acc-toggle';
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = label;
        var body = document.createElement('div');
        body.className = 'cr-mega-drawer__acc-panel';

        var grid = document.createElement('div');
        grid.className = 'cr-mega-drawer__grid';
        grid.appendChild(drawerBodyFor(panel));
        body.appendChild(grid);

        var saText = shopAllTextFor(panel, label);
        if (saText) {
          var sa = document.createElement('div');
          sa.className = 'cr-mega-drawer__shopall';
          sa.innerHTML = '<a href="' + href + '"></a>';
          sa.firstChild.textContent = saText;
          body.appendChild(sa);
        }

        btn.addEventListener('click', function () {
          var open = group.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });

        group.appendChild(btn);
        group.appendChild(body);
        wrap.appendChild(group);
      });

      panels.appendChild(wrap);
    }

    function buildDrawer() {
      if (!panels) return;
      if (root.dataset.drawerStyle === 'accordion') { buildAccordion(); return; }
      drawer.classList.remove('cr-mega-drawer--acc');
      panels.innerHTML = '';

      var rootPanel = document.createElement('div');
      rootPanel.className = 'cr-mega-drawer__panel is-current';
      rootPanel.setAttribute('data-cr-panel', 'root');
      var list = document.createElement('ul');
      list.className = 'cr-mega-drawer__list';
      rootPanel.appendChild(list);
      panels.appendChild(rootPanel);

      root.querySelectorAll('[data-cr-item]').forEach(function (item, i) {
        var link = item.querySelector('.cr-mega__link');
        if (!link) return;
        var label = (link.textContent || '').trim();
        var href = link.getAttribute('href') || '#';
        var panel = item.querySelector('.cr-mega__panel');
        var hasCards = panel && panel.querySelector('.cr-mega__card');
        var li = document.createElement('li');

        if (!hasCards) {
          // Hero-style items (no sub-items) go straight to their page.
          li.innerHTML = '<a href="' + href + '">' + label + '</a>';
          list.appendChild(li);
          return;
        }

        var id = 'i' + i;
        var btn = document.createElement('button');
        btn.setAttribute('data-cr-goto', id);
        btn.innerHTML = label + CARET;
        li.appendChild(btn);
        list.appendChild(li);

        var sub = document.createElement('div');
        sub.className = 'cr-mega-drawer__panel';
        sub.setAttribute('data-cr-panel', id);

        var back = document.createElement('button');
        back.className = 'cr-mega-drawer__back';
        back.setAttribute('data-cr-back', '');
        back.innerHTML = CARET + ' All Categories';
        sub.appendChild(back);

        var saText = shopAllTextFor(panel, label);
        if (saText) {
          var sa = document.createElement('div');
          sa.className = 'cr-mega-drawer__shopall';
          sa.innerHTML = '<a href="' + href + '"></a>';
          sa.firstChild.textContent = saText;
          sub.appendChild(sa);
        }

        var grid = document.createElement('div');
        grid.className = 'cr-mega-drawer__grid';
        grid.appendChild(drawerBodyFor(panel));
        sub.appendChild(grid);

        panels.appendChild(sub);
      });

      wireDrawerNav();
    }

    function setPanel(id, backwards) {
      panels.querySelectorAll('[data-cr-panel]').forEach(function (p) {
        p.classList.remove('is-current', 'is-behind');
        if (p.dataset.crPanel === id) p.classList.add('is-current');
        else if (backwards ? false : stack.indexOf(p.dataset.crPanel) !== -1) p.classList.add('is-behind');
      });
    }
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.hidden = false;
      burger.setAttribute('aria-expanded', 'true');
      // Lazy images never qualify as "near viewport" inside the transformed,
      // display:none-panelled drawer, so they stay unloaded; flip them to
      // eager the first time the drawer opens.
      drawer.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      stack = ['root'];
      setPanel('root', true);
    }
    function wireDrawerNav() {
      drawer.querySelectorAll('[data-cr-goto]').forEach(function (b) {
        b.addEventListener('click', function () {
          stack.push(b.dataset.crGoto);
          setPanel(b.dataset.crGoto);
        });
      });
      drawer.querySelectorAll('[data-cr-back]').forEach(function (b) {
        b.addEventListener('click', function () {
          stack.pop();
          setPanel(stack[stack.length - 1] || 'root', true);
        });
      });
    }

    bindChrome();

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDrawer();
      if (document.activeElement && root.contains(document.activeElement)) document.activeElement.blur();
    });

    root.querySelectorAll('[data-cr-item]').forEach(function (item) {
      var link = item.querySelector('.cr-mega__link');
      if (!link) return;
      item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); });
      item.addEventListener('focusin', function () { link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('focusout', function () { link.setAttribute('aria-expanded', 'false'); });
    });

    // Tag the dropdowns that hold two or more rows of photos so the CSS can
    // shrink just those to fit a short window (.cr-mega__panel--two-rows).
    // Count real cards against each grid's column count: a hidden promo slot
    // renders as an empty block, so counting blocks would over-count.
    root.querySelectorAll('.cr-mega__panel').forEach(function (panel) {
      var rows = 0;
      panel.querySelectorAll('.cr-mega__cards').forEach(function (grid) {
        var cols = parseInt(grid.style.getPropertyValue('--cols'), 10) || 4;
        rows += Math.ceil(grid.querySelectorAll('.cr-mega__card').length / cols);
      });
      panel.classList.toggle('cr-mega__panel--two-rows', rows >= 2);
    });

    // The desktop panels' photos are loading="lazy" inside display:none
    // panels, so the browser never fetches them until a panel opens, and on a
    // busy page that took seconds: the first hover on each item showed grey
    // tiles. All 21 photos weigh ~0.9 MB on a regular screen and ~3.8 MB on a
    // retina one, so don't pull them all for visitors who never open the
    // menu: once the page has finished loading and the browser is idle, warm
    // only the first dropdown, and only where dropdowns can be used (a window
    // wide enough for the inline menu, on a device that hovers) so phones and
    // tablets never download them. The rest start as soon as the pointer or
    // keyboard focus reaches the nav. The drawer does the same on open
    // (openDrawer).
    var deskNav = root.querySelector('.cr-mega__nav');
    if (deskNav) {
      var startPhotos = function (scope) {
        scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          img.loading = 'eager';
        });
      };
      var startAllPanelPhotos = function () { startPhotos(deskNav); };
      deskNav.addEventListener('mouseenter', startAllPanelPhotos);
      deskNav.addEventListener('focusin', startAllPanelPhotos);

      var firstItem = deskNav.querySelector('[data-cr-item]');
      if (firstItem && window.matchMedia('(min-width: 1180px) and (hover: hover)').matches) {
        var warmFirstPanel = function () {
          var go = function () { startPhotos(firstItem); };
          if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 4000 });
          else setTimeout(go, 1500);
        };
        if (document.readyState === 'complete') warmFirstPanel();
        else window.addEventListener('load', warmFirstPanel, { once: true });
      }
    }

    // ---- Filter pills ------------------------------------------------------
    function activeValue(panelInner, group) {
      var on = panelInner.querySelector('[data-cr-pills="' + group + '"] .on');
      return on ? (on.dataset.crPill || '') : '';
    }
    function matches(cardValue, pillValue) {
      if (!cardValue) return true;
      if (ALL_VALUES.indexOf(pillValue) !== -1) return true;
      return cardValue === pillValue;
    }
    root.querySelectorAll('[data-cr-pills]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cr-pill]');
        if (!btn) return;
        group.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');

        var inner = group.closest('.cr-mega__panel-inner');
        var v1 = activeValue(inner, '1');
        var v2 = activeValue(inner, '2');
        // NB: read these with getAttribute — a data-* name ending in a digit
        // maps to dataset['crFilter-1'], not dataset.crFilter1.
        inner.querySelectorAll('.cr-mega__card').forEach(function (card) {
          var c1 = card.getAttribute('data-cr-filter-1') || '';
          var c2 = card.getAttribute('data-cr-filter-2') || '';
          var show = matches(c1, v1) && matches(c2, v2);
          card.classList.toggle('is-filtered-out', !show);
        });
      });
    });

    // Publish the real header height so the announcement bar can sit below it.
    function publishHeight() {
      document.documentElement.style.setProperty('--cr-header-h', root.offsetHeight + 'px');
    }
    publishHeight();
    window.addEventListener('resize', publishHeight, { passive: true });

    // ---- Sticky "hide on scroll down, show on scroll up" --------------------
    if (root.classList.contains('cr-mega--sticky-scroll-up')) {
      var lastY = window.scrollY;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (Math.abs(y - lastY) < 6) return;
        // Never hide it while the mobile drawer is open.
        var drawerOpen = drawer && drawer.classList.contains('is-open');
        root.classList.toggle('is-hidden', y > lastY && y > root.offsetHeight && !drawerOpen);
        lastY = y;
      }, { passive: true });
    }

    // Hoisted, so the bindChrome() call further up runs before this point.
    function bindChrome() {
      if (burger) burger.addEventListener('click', openDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
      var closeBtn = drawer && drawer.querySelector('[data-cr-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    }

    // The theme editor swaps this section's DOM wholesale on every save and
    // block select. That discards the listeners bindChrome() attached, so the
    // freshly rendered burger has nothing wired to it and the drawer stops
    // opening until the editor is reloaded.
    //
    // Re-resolving into the SAME variable names is the point: every closure
    // in this script reads root/drawer/overlay/burger/panels from this scope,
    // so one reassignment repairs all of them. Guarded on node identity
    // because shopify:section:load also fires for unrelated sections, and
    // re-binding an untouched burger would stack duplicate listeners.
    function rebind() {
      var nextRoot = document.querySelector('.cr-mega');
      if (!nextRoot) return;
      if (nextRoot !== root) {
        root = nextRoot;
        drawer = document.querySelector('[data-cr-drawer]');
        overlay = document.querySelector('[data-cr-overlay]');
        burger = root.querySelector('[data-cr-burger]');
        panels = drawer ? drawer.querySelector('[data-cr-panels]') : null;
        stack = ['root'];
        bindChrome();
      }
      buildDrawer();
    }

    buildDrawer();

    document.addEventListener('shopify:section:load', rebind);
    document.addEventListener('shopify:block:select', rebind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-v2"] && !Shopify.designMode) return;
  try {
    
  class HeroV2Video extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video.hero-v2__media');
      if (!this.video) return;
      this.mq = window.matchMedia('(max-width: 749px)');
      this.current = null;
      this.apply = this.apply.bind(this);
      this.mq.addEventListener('change', this.apply);
      this.apply();
      this.initPlayPause();
    }

    // WCAG 2.2.2: auto-playing motion needs a control that stops it, for
    // keyboard and switch users, not just a hover pause.
    initPlayPause() {
      const btn = this.querySelector('[data-hero-playpause]');
      if (!btn || !this.video) return;
      const sync = () => {
        const paused = this.video.paused;
        btn.classList.toggle('is-paused', paused);
        btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      };
      btn.addEventListener('click', () => {
        if (this.video.paused) { this.video.play().catch(() => {}); } else { this.video.pause(); }
      });
      this.video.addEventListener('play', sync);
      this.video.addEventListener('pause', sync);
      // Only show the control when the video actually autoplays.
      this.video.addEventListener('playing', () => { btn.hidden = false; }, { once: true });
      sync();
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.apply);
    }

    // A phone on cellular should never be handed a 1080p file. Pick the
    // rendition that fits the device, and drop a tier again when the
    // browser reports a slow or metered connection.
    pickSource(mobile) {
      const set = mobile ? 'mobile' : 'desktop';
      const tiers = { '480': 'Low', '720': 'Mid', '1080': 'High' };
      const at = (h) => this.dataset[set + tiers[h]] || '';
      const conn = navigator.connection || {};
      const slow = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');

      // Native HLS (Safari, iOS) — adaptive, starts on a low rendition
      // instead of committing to the whole 1080p file.
      const hls = this.dataset[set + 'Hls'];
      if (hls && this.video.canPlayType('application/vnd.apple.mpegurl')) {
        return { url: hls, slow };
      }

      const ladder = mobile
        ? slow
          ? ['480', '720', '1080']
          : ['720', '480', '1080']
        : slow
          ? ['720', '480', '1080']
          : ['1080', '720', '480'];

      for (const step of ladder) {
        if (at(step)) return { url: at(step), slow };
      }
      // Nothing for this device — fall back to whatever the other one has.
      return { url: (mobile ? this.dataset.desktopSrc : this.dataset.mobileSrc) || '', slow };
    }

    apply() {
      const mobile = this.mq.matches;
      const { url: src, slow } = this.pickSource(mobile);
      const poster = (mobile && this.dataset.mobilePoster) || this.dataset.desktopPoster;

      // Poster first, always: it paints immediately and stays up while the
      // video buffers, so the hero is never a black rectangle.
      if (poster && this.video.poster !== poster) this.video.poster = poster;
      if (!src || src === this.current) return;
      this.current = src;
      this.video.src = src;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // On a metered/2g connection, leave the poster up rather than pulling
      // megabytes the visitor is paying for.
      if (this.hasAttribute('data-autoplay') && !reduced && !slow) {
        this.video.play().catch(() => {
          this.video.controls = true;
        });
      } else {
        this.video.controls = true;
      }
    }
  }

  if (!customElements.get('hero-v2-video')) {
    customElements.define('hero-v2-video', HeroV2Video);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection_backup"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-kit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-mediakit-copy]');
    if (!btn) return;
    const text = btn.closest('.mediakit__caption')?.querySelector('[data-mediakit-text]')?.textContent.trim();
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      btn.setAttribute('data-copied', '');
      const label = btn.textContent;
      btn.textContent = 'Copied';
      setTimeout(() => {
        btn.removeAttribute('data-copied');
        btn.textContent = label;
      }, 1600);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-beanbags"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sb]');
    if (!root) return;

    var rail = root.querySelector('[data-sb-rail]');
    var groupsHost = root.querySelector('[data-sb-groups]');
    if (!rail || !groupsHost) return;

    // One block list feeds two regions: size chips stay in the rail, product
    // groups get moved into the grid area below.
    Array.prototype.slice.call(rail.children).forEach(function (wrapper) {
      if (wrapper.querySelector('[data-sb-group]')) groupsHost.appendChild(wrapper);
    });

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-sb-chip]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sb-group]'));
    var clear = root.querySelector('[data-sb-clear]');
    var activeChip = null;

    function apply(sqft) {
      groups.forEach(function (g) {
        var min = parseFloat(g.getAttribute('data-min-sqft'));
        var max = parseFloat(g.getAttribute('data-max-sqft'));
        var show = sqft === null || (sqft >= min && sqft <= max);
        g.classList.toggle('is-hidden', !show);
      });
      if (clear) clear.hidden = sqft === null;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var sqft = parseFloat(chip.getAttribute('data-sqft'));
        if (activeChip === chip) {
          activeChip = null;
          chip.setAttribute('aria-pressed', 'false');
          apply(null);
          return;
        }
        activeChip = chip;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        apply(sqft);
        var first = groups.filter(function (g) { return !g.classList.contains('is-hidden'); })[0];
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (clear) {
      clear.addEventListener('click', function () {
        activeChip = null;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        apply(null);
      });
    }

    apply(null);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sg]');
    if (!root) return;

    // Hero video pause/play (WCAG 2.2.2 — moving content needs a stop control)
    var vidWrap = root.querySelector('[data-sg-video]');
    if (vidWrap) {
      var vid = vidWrap.querySelector('video');
      var toggle = vidWrap.querySelector('[data-sg-video-toggle]');
      if (vid && toggle) {
        toggle.addEventListener('click', function () {
          var paused = vid.paused;
          if (paused) { vid.play(); } else { vid.pause(); }
          toggle.setAttribute('aria-label', paused ? 'Pause video' : 'Play video');
          toggle.querySelector('.sg-hero__icon-pause').hidden = !paused;
          toggle.querySelector('.sg-hero__icon-play').hidden = paused;
        });
      }
    }

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sg-item]'));
    if (!cards.length) return;

    var room = root.querySelector('[data-sg-room]');
    var PX_PER_FT = 22;
    var active = null;

    function num(el, attr) { return parseFloat(el.getAttribute(attr)) || 0; }
    function isConvertible(el) { return el.getAttribute('data-convertible') === 'true'; }

    // ---- Filters -----------------------------------------------------------
    root.querySelectorAll('[data-sg-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-sg-filter');
        root.querySelectorAll('[data-sg-filter]').forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
        cards.forEach(function (card) {
          var conv = isConvertible(card);
          var show = mode === 'all' || (mode === 'convertible' && conv) || (mode === 'chair' && !conv);
          // hide the Shopify block wrapper, not the card, so the grid reflows
          (card.closest('.shopify-block') || card).classList.toggle('is-hidden', !show);
        });
      });
    });

    if (!room) return;

    // ---- Room visualizer ---------------------------------------------------
    var elTitle = room.querySelector('[data-sg-room-title]');
    var elSac = room.querySelector('[data-sg-sac]');
    var elBed = room.querySelector('[data-sg-bed]');
    var elZone = room.querySelector('[data-sg-zone]');
    var elFrame = room.querySelector('[data-sg-frame]');
    var elDimW = room.querySelector('[data-sg-dim-w]');
    var elDimH = room.querySelector('[data-sg-dim-h]');
    var elLegSac = room.querySelector('[data-sg-legend-sac]');
    var elLegBed = room.querySelector('[data-sg-legend-bed]');
    var elLegBedRow = room.querySelector('[data-sg-legend-bed-row]');
    var elLegSleeps = room.querySelector('[data-sg-legend-sleeps]');
    var elLegSleepsRow = room.querySelector('[data-sg-sleeps-row]');
    var pick = room.querySelector('[data-sg-pick]');

    function show(card) {
      active = card;
      var name = card.getAttribute('data-name') || 'This size';
      var floor = num(card, 'data-floor');
      var feet = num(card, 'data-room') || 12;
      var conv = isConvertible(card);

      cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });
      if (pick) pick.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-for') === name);
      });

      elTitle.textContent = name + ' in a ' + feet + '×' + feet + ' room.';
      elDimW.textContent = feet + "'";
      elDimH.textContent = feet + "'";
      elFrame.style.setProperty('--rw', (feet * PX_PER_FT) + 'px');
      elFrame.style.setProperty('--rh', (feet * PX_PER_FT) + 'px');

      var sacPx = (floor / 12) * PX_PER_FT;
      elSac.style.width = sacPx + 'px';
      elSac.style.height = sacPx + 'px';
      elSac.style.background = card.style.getPropertyValue('--sg-tone') || '#272838';

      var zonePx = ((floor / 12) + 3) * PX_PER_FT;
      elZone.style.width = zonePx + 'px';
      elZone.style.height = zonePx + 'px';

      elLegSac.textContent = floor + ' in. × ' + floor + ' in.';

      if (conv) {
        var bw = num(card, 'data-bed-w'), bl = num(card, 'data-bed-l');
        elBed.hidden = false;
        elBed.style.width = ((bw / 12) * PX_PER_FT) + 'px';
        elBed.style.height = ((bl / 12) * PX_PER_FT) + 'px';
        elLegBedRow.hidden = false;
        elLegBed.textContent = bw + ' in. × ' + bl + ' in.';
      } else {
        elBed.hidden = true;
        elLegBedRow.hidden = true;
      }

      // sleeps/seats — decision-grade line inherited from the classic
      // sizing graphics ("Sleeps 2 adults / Seats 1 large adult")
      if (elLegSleeps && elLegSleepsRow) {
        var sleeps = card.getAttribute('data-sleeps') || '';
        elLegSleepsRow.hidden = !sleeps;
        elLegSleeps.textContent = sleeps;
      }
    }

    // Build the size picker from the cards themselves
    if (pick) {
      cards.forEach(function (card) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = card.getAttribute('data-name') || 'Size';
        b.setAttribute('data-for', card.getAttribute('data-name') || '');
        b.addEventListener('click', function () { show(card); });
        pick.appendChild(b);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // let real links through; card selection is a secondary action
        if (e.target.closest('a')) return;
        show(card);
      });
    });

    room.hidden = false;
    var starred = cards.filter(function (c) { return c.classList.contains('sg-card--star'); });
    show(starred[0] || cards[0]);

    document.addEventListener('shopify:section:load', function () { location.reload(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
